import React, {useState, useEffect} from 'react'
import styles from './LogInView.module.scss'
import {Button} from '@mui/material'
import optionsStore from '../../zustand/optionsStore'
import userStore from '../../zustand/userStore'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDiscord } from '@fortawesome/free-brands-svg-icons'
import {motion} from 'framer-motion'
import { logoCircleAnim, logoLineAnim, helloPAnim } from '../../animations/animations'
import { useNavigate } from 'react-router-dom'

const LogInView = () => {
  const lng = optionsStore(state => state.language)
  const auth = userStore(state => state.auth)
  const logIn = userStore(state => state.logIn)
  const [animEnded, setAnimEnded] = useState(false)
  const [isLoaded, setIsLoaded] = useState(false)
  const navigate = useNavigate()
  const checkToken = async () => {
    let token = window.localStorage.getItem('encryptedToken')
    if(token){
      logIn(token, navigate)
    }else{
      setIsLoaded(true)
      setTimeout(() => {setAnimEnded(true)}, 650)
    }
  }
  useEffect(() => {
    checkToken()
  }, [])
  return (
    <div className={styles.wrapper}>
      {isLoaded && <>
      <div className={styles.top}>
        <div className={styles.pContainer}>
          {animEnded && <motion.p variants={helloPAnim} initial="start" animate="end" className={styles.helloP}>{lng.logIn.hello}</motion.p>}
        </div>
        <div className={styles.logoSvg}>
          <svg width="100%" height="100%" viewBox="0 0 216 75" fill="none" xmlns="http://www.w3.org/2000/svg">
            {animEnded && <motion.path  variants={logoLineAnim} initial="start" animate="end" d="M160 71V44" stroke="#FFCB21"  strokeLinecap="round" strokeLinejoin="round"  strokeWidth="6"/>}
            <motion.path variants={logoCircleAnim} initial="start" animate="end" d="M110 46.0208V42.5212C110 28.9007 120.899 17.7842 134.516 17.5145C148.703 17.2336 160.282 28.7974 160.019 42.9843L159.954 46.4834C159.702 60.0963 148.594 71 134.979 71C121.184 71 110 59.8165 110 46.0208Z" stroke="#FFCB21" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M212.5 30.5014C199.35 20.7605 184 24.0028 181 30.5014C178 36.9999 179.695 40.8551 186.5 44.5C207.609 49.072 212.5 51 212.5 58.0006C212.5 65.0011 209.5 68 202 70.5006C192 72 187.13 71.1514 178.5 63.5006" stroke="#FFCB21"  strokeLinecap="round" strokeLinejoin="round" strokeWidth="6"/>
            <path d="M81.0006 8.5V56.5C80.8324 67.0455 83.6438 70.2173 96.5006 69" stroke="#FFCB21" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M70 25.5H95.5" stroke="#FFCB21" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M3 69L10.9091 51M61 69L53.0909 51M53.0909 51L32 3L10.9091 51M53.0909 51H10.9091" stroke="#FFCB21" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
      </div>
      <div className={styles.bottom}>
        <Button onClick={auth} style={{color: 'white', backgroundColor: '#7289DA', width: '90%', padding: '1rem', fontSize: '1.1rem'}}
         variant="contained">{lng.logIn.btn1} &nbsp; <FontAwesomeIcon icon={faDiscord} /></Button>
        <Button style={{color: 'white',  width: '90%', padding: '1rem'}} variant="text">{lng.logIn.btn2}</Button>
      </div>
      </>}
    </div>
  )
}

export  default LogInView
